import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107129Status: 'idle',
    startProcess107129Error: undefined as any,
    loadUserParamsProcess107129Status: 'idle',
    loadUserParamsProcess107129Error: undefined as any,

    process107129List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107129 = createAsyncThunk('process107129Slice/startProcess107129', async ({ process107129 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107129/`,
        prepareData(process107129),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107129Status } = getState().process107129Slice
        return startProcess107129Status !== 'pending'
    }
})

export const loadUserParamsProcess107129 = createAsyncThunk('process107129Slice/loadUserParamsProcess107129', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107129/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107129Status } = getState().process107129Slice
        return loadUserParamsProcess107129Status !== 'pending'
    }
})

const Process107129Slice = createSlice({
    name: 'process107129Slice',
    initialState,
    reducers: {
        resetstartProcess107129: (state) => {
            state.job = undefined
            state.startProcess107129Error = undefined
        },
        resetstartProcess107129Error: (state) => {
            state.startProcess107129Error = undefined
        },
        resetloadUserParamsProcess107129: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107129Error = undefined
        },
        resetloadUserParamsProcess107129Error: (state) => {
            state.loadUserParamsProcess107129Error = undefined
        },
        removeFromProcess107129ListById: (state, action) => {
            state.process107129List = state.process107129List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107129ListByIds: (state, action) => {
            state.process107129List = state.process107129List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107129List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107129Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107129List = []
            state.startProcess107129Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107129.pending, (state) => {
            state.startProcess107129Status = 'pending'
            state.startProcess107129Error = undefined
        })
        builder.addCase(startProcess107129.fulfilled, (state, action) => {
            state.startProcess107129Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107129.rejected, (state, action) => {
            state.startProcess107129Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107129Error = action.error.message
            } else {
                state.startProcess107129Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107129.pending, (state) => {
            state.loadUserParamsProcess107129Status = 'pending'
            state.loadUserParamsProcess107129Error = undefined
        })
        builder.addCase(loadUserParamsProcess107129.fulfilled, (state, action) => {
            state.loadUserParamsProcess107129Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107129.rejected, (state, action) => {
            state.loadUserParamsProcess107129Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107129Error = action.error.message
            } else {
                state.loadUserParamsProcess107129Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107129,
    resetstartProcess107129Error,
    resetloadUserParamsProcess107129,
    resetloadUserParamsProcess107129Error,
    removeFromProcess107129ListById,
    removeFromProcess107129ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107129Slice.actions
export default Process107129Slice.reducer
